/* 
    Sankey Module 
*/
import cloneDeep from 'lodash/cloneDeep';
import sankeyConfigBuilder from './sankey-config-builder';
import d3Utils from '../../../utils/d3Utils';
import chartUtils from '../../../utils/chart-utils';
import sankey from '../../../utils/d3.sankey';
import { sankeyTooltip } from '../../widgets/widget-utilities/widget-tooltip';

var sankeyFlow = function sankeyFlow() {

    // Render Sankey flow widget
    var renderWidget = function renderWidget(widgetConfig) {
        var ContainerId = widgetConfig.ContainerId,
            Height = widgetConfig.Height,
            Width = widgetConfig.Width,
            Model = widgetConfig.Model,
            Cloud = widgetConfig.Cloud,
            StampText = widgetConfig.StampText,
            Data = widgetConfig.Data,
            FlowConfig = widgetConfig.FlowConfig;


        var el = window.document.querySelector('#' + ContainerId);
        var parentContainerId = ContainerId.includes('flip-') ? ContainerId.split('flip-')[1] : ContainerId;
        d3.select(el).select('svg').remove();

        var modelName = Model;
        var cloudName = Cloud;
        // Rendering logic is expecting data to be array of array
        var data = [];
        data.push(JSON.parse(chartUtils.replaceAll(Data.data, '\x01', "")));
        var width = Number(Width);
        var height = Number(Height);

        var margin = {
            top: 0.1 * height,
            right: 0.1 * width,
            bottom: 0.1 * height,
            left: 0.1 * width
        };
        width = width - margin.left - margin.right;
        height = height - margin.top - margin.bottom;
        var crumbFormat = { 'CloudName': cloudName, 'ModelName': modelName, 'Type': 'Node', 'Name': '', 'FieldName': '', 'Value': '' };
        var valueFieldName = FlowConfig.ValueFieldName;

        var showLabels = FlowConfig.ShowLabels;
        var tipField = FlowConfig.TipField;
        var stampText = StampText;
        var tooltipConfig = FlowConfig.CompoundTipField;
        var displayFormat = FlowConfig.ValueFormat;
        var currencyPrefix = FlowConfig.CurrencySymbol;
        var baseFormat = FlowConfig.BaseFormat;
        var accumulationType = FlowConfig.AggregationType;
        var TRANSITION = 750;
        var MAX_OPACITY = 1;
        var NORMAL_OPACITY = 0.5;
        var MIN_OPACITY = 0.1;

        if (tooltipConfig != null && tooltipConfig.toString().trim().length > 0) tooltipConfig = JSON.parse(chartUtils.replaceAll(JSON.stringify(tooltipConfig), '\x01', ''));

        var accumulator = {};
        var nodes = [];
        var links = [];
        var counter = 0;

        var fieldsLength = FlowConfig.Fields.length;
        var sourceNodeName = null;
        var targetNodeName = null;
        var crumbFieldName = null;
        var targetCrumbFieldName = null;
        var crumbMetaName = null;
        var targetCrumbMetaName = null;
        var flowField = FlowConfig.Fields[0];

        if (flowField) {
            sourceNodeName = flowField.FieldName;
            crumbFieldName = flowField.CrumbFieldName;
            crumbMetaName = flowField.CrumbMetaName;
        }

        for (var flowIndex = 0; flowIndex < fieldsLength - 1; flowIndex++) {
            targetNodeName = FlowConfig.Fields[flowIndex + 1].FieldName;
            targetCrumbFieldName = FlowConfig.Fields[flowIndex + 1].CrumbFieldName;
            targetCrumbMetaName = FlowConfig.Fields[flowIndex + 1].CrumbMetaName;

            for (var dataIndex = 0; dataIndex < data[0].length; dataIndex++) {
                var item = data[0][dataIndex];

                if (item[sourceNodeName] == null || item[targetNodeName] == null || item[sourceNodeName] == '#N/A' || item[targetNodeName] == '#N/A') continue;

                var sourceNode = chartUtils.findValue(nodes, 'field', item[sourceNodeName]);
                var targetNode = chartUtils.findValue(nodes, 'field', item[targetNodeName]);

                var value = 0;
                if (item[valueFieldName] != null || !isNaN(Number(item[valueFieldName]))) value = Number(item[valueFieldName]);

                var link = null;

                if (sourceNode != null && targetNode != null) {
                    sourceNode.value += value;
                    targetNode.value += value;

                    link = chartUtils.findLink(links, 'source', sourceNode['node'], 'target', targetNode['node']);

                    if (link == null) link = chartUtils.findLink(links, 'source', targetNode['node'], 'target', sourceNode['node']);

                    if (link != null) {
                        if (item[valueFieldName] != null) link['value'] += value;

                        continue;
                    }
                }

                if (sourceNode == null) {
                    sourceNode = {};
                    sourceNode['node'] = counter;
                    sourceNode['field'] = item[sourceNodeName];
                    sourceNode['value'] = value;

                    if (tooltipConfig != null && tooltipConfig.TooltipConfigs != null && tooltipConfig.TooltipConfigs.length > 0) for (var index = 0; index < tooltipConfig.TooltipConfigs.length; index++) {
                        sourceNode[tooltipConfig.TooltipConfigs[index].Id] = item[tooltipConfig.TooltipConfigs[index].Id];
                    }if (crumbFieldName && item[crumbFieldName]) {
                        sourceNode['crumbFieldName'] = item[crumbFieldName];
                        sourceNode['crumbDisplayFieldName'] = crumbFieldName;
                        sourceNode['crumbMetaName'] = crumbMetaName;
                    }

                    nodes.push(sourceNode);
                    counter++;
                }

                if (targetNode == null) {
                    targetNode = {};
                    targetNode['node'] = counter;
                    targetNode['field'] = item[targetNodeName];
                    targetNode['value'] = value;

                    if (tooltipConfig != null && tooltipConfig.TooltipConfigs != null && tooltipConfig.TooltipConfigs.length > 0) for (var _index = 0; _index < tooltipConfig.TooltipConfigs.length; _index++) {
                        targetNode[tooltipConfig.TooltipConfigs[_index].Id] = item[tooltipConfig.TooltipConfigs[_index].Id];
                    }if (crumbFieldName != null && item[crumbFieldName] != null) {
                        targetNode['crumbFieldName'] = item[targetCrumbFieldName];
                        targetNode['crumbDisplayFieldName'] = targetCrumbFieldName;
                        targetNode['crumbMetaName'] = targetCrumbMetaName;
                    }

                    nodes.push(targetNode);
                    counter++;
                }

                link = {};
                link['source'] = sourceNode['node'];
                link['target'] = targetNode['node'];
                link['value'] = 0;

                if (tooltipConfig != null && tooltipConfig.TooltipConfigs != null && tooltipConfig.TooltipConfigs.length > 0) for (var _index2 = 0; _index2 < tooltipConfig.TooltipConfigs.length; _index2++) {
                    link[tooltipConfig.TooltipConfigs[_index2].Id] = item[tooltipConfig.TooltipConfigs[_index2].Id];
                }if (!!crumbFieldName && !!item[crumbFieldName]) link[crumbFieldName] = item[crumbFieldName];

                if (item[valueFieldName] != null) link['value'] = value;

                if (valueFieldName == null || valueFieldName.trim().length == 0) link['value']++;

                links.push(link);
            }

            sourceNodeName = targetNodeName;
            crumbFieldName = targetCrumbFieldName;
            crumbMetaName = targetCrumbMetaName;
        }

        accumulator['nodes'] = nodes;
        accumulator['links'] = links;

        var chartWidth = width + margin.left + margin.right;
        var chartHeight = height + margin.top + margin.bottom;

        var svg = d3.select(el).append('svg').attr('width', chartWidth).attr('height', chartHeight).attr('innerheight', height).attr('innerWidth', width).attr('viewBox', '0 0 ' + chartWidth + ' ' + chartHeight).attr('preserveAspectRatio', 'xMidYMid').attr('class', 'maximize-trigger').append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')').attr('class', 'chart');

        var color = d3.scale.category20();

        var nodeSize = height / accumulator.nodes.length;

        var padding = nodeSize > 0.01 * height ? nodeSize * 0.25 : 1;

        //Set the sankey diagram properties
        var sankeyName = sankey.nodeWidth(36).nodePadding(padding).size([width, height]);

        sankeyName.nodes(accumulator.nodes).links(accumulator.links).layout(32);

        var path = sankeyName.link();

        //Add the links
        link = svg.append('g').selectAll('.link');

        link.data(accumulator.links).enter().append('path').attr('class', 'link dataviz').attr('d', path).style('stroke-width', function (d) {
            return Math.max(1, d.dy);
        }).sort(function (a, b) {
            return b.dy - a.dy;
        }).attr('coord', function (d) {
            crumbFormat.Value = d[crumbFieldName];
            return JSON.stringify(crumbFormat);
        }).attr('stroke-dasharray', function () {
            var totalLength = this.getTotalLength();
            return totalLength + ' ' + totalLength;
        }).style('stroke', function (d) {
            return color(d.source.field);
        }).attr('stroke-dashoffset', function () {
            return this.getTotalLength();
        }).attr('label', function (d) {
            if (tipField != null) return "<span class='tip-header'>" + d.field + " - " + tipField + ":</span><span class='tip-value'> " + chartUtils.format(d.value, displayFormat, currencyPrefix, null, baseFormat) + "</span>";

            var defaultTip = "<span class='tip-header'>" + valueFieldName + ":</span><span class='tip-value'> " + chartUtils.format(d.value, displayFormat, currencyPrefix, null, baseFormat) + "</span>";

            var tipText = chartUtils.buildTooltipText(tooltipConfig, d, defaultTip, valueFieldName, accumulationType, null);
            return tipText;
        }).on("touchstart", function () {
            sankeyTooltip.onMouseOver.call(this, parentContainerId);
        }).on("mouseover", function () {
            sankeyTooltip.onMouseOver.call(this, parentContainerId);
            var linkElements = this.closest('svg').getElementsByClassName('link');
            Array.from(linkElements).forEach(function (element) {
                element.style.opacity = MIN_OPACITY;
            });
            this.style.opacity = MAX_OPACITY;
        }).on("mouseout", function () {
            sankeyTooltip.onMouseOut.call(this, parentContainerId);
            var linkElements = this.closest('svg').getElementsByClassName('link');
            Array.from(linkElements).forEach(function (element) {
                element.style.opacity = NORMAL_OPACITY;
            });
        }).on("touchmove", sankeyTooltip.onTouchMove).on("mousemove", function () {
            sankeyTooltip.onMouseMove.call(this, parentContainerId);
        }).transition().delay(TRANSITION).duration(TRANSITION).ease('linear').attr('stroke-dashoffset', 0);

        //Add in the nodes
        var node = svg.append('g').selectAll('.node').data(accumulator.nodes).enter().append('g').attr('class', 'node').attr('transform', function (d) {
            return 'translate(' + d.x + ',' + d.y + ')';
        });

        //Add rectangles for the nodes
        node.append('rect').attr("height", 0).attr("width", 0).attr('class', 'dataviz').on("touchstart", function () {
            sankeyTooltip.onMouseOver.call(this, parentContainerId);
        }).on("mouseover", function () {
            var _this = this;

            sankeyTooltip.onMouseOver.call(this, parentContainerId);
            var linkElements = this.closest('svg').getElementsByClassName('link');
            Array.from(linkElements).forEach(function (element) {
                var dataElement = d3.select(element).data()[0];
                var fieldElement = d3.select(_this).data()[0].field;
                if (dataElement.source.field === fieldElement || dataElement.target.field === fieldElement) {
                    element.style.opacity = MAX_OPACITY;
                } else {
                    element.style.opacity = MIN_OPACITY;
                }
            });
        }).on("mouseout", function () {
            sankeyTooltip.onMouseOut.call(this, parentContainerId);
            var linkElements = this.closest('svg').getElementsByClassName('link');
            Array.from(linkElements).forEach(function (element) {
                element.style.opacity = NORMAL_OPACITY;
            });
        }).on("touchmove", sankeyTooltip.onTouchMove).on("mousemove", function () {
            sankeyTooltip.onMouseMove.call(this, parentContainerId);
        }).transition().duration(TRANSITION).ease("bounce").attr("height", function (d, i) {
            return height[i];
        }).attr("width", function (d, i) {
            return width[i];
        }).attr('height', function (d) {
            return d.dy;
        }).attr('width', sankeyName.nodeWidth()).style('fill', function (d) {
            return color(d.field);
        }).attr('label', function (d) {
            if (tipField != null) return "<span class='tip-header'>" + d.field + " - " + tipField + ":</span><span class='tip-value'> " + chartUtils.format(d.value, displayFormat, currencyPrefix, null, baseFormat) + "</span>";

            var defaultTip = "<span class='tip-header'>" + d.field + ":</span><span class='tip-value'> " + chartUtils.format(d.value, displayFormat, currencyPrefix, null, baseFormat) + "</span>";

            var tipText = chartUtils.buildTooltipText(tooltipConfig, d, defaultTip, valueFieldName, accumulationType, null);
            return tipText;
        }).attr('coord', function (d) {
            crumbFormat.Name = d.crumbMetaName;
            crumbFormat.FieldName = d.crumbDisplayFieldName;
            crumbFormat.Value = d.crumbFieldName;
            return JSON.stringify(crumbFormat);
        });

        var labelThreshold = 20;

        //Add titles for the nodes
        if (showLabels) {
            var label = node.append('text').attr('class', 'sankey-label').attr('x', function () {
                return sankeyName.nodeWidth() / 2;
            }).attr('y', function (d) {
                return d.dy / 2;
            }).attr('dy', '0.35em').attr('text-anchor', 'middle').text(function (d) {
                var labelText = d.field;
                if (d.dy < 4) return "...";else if (labelText.length > labelThreshold) return labelText.substring(0, labelThreshold - 2) + "...";
                return labelText;
            }).style('font-size', function (d) {
                var maxFontSize = Math.round(height * 0.05);
                var fontSize = Math.round(d.dy * 0.5);
                if (fontSize > maxFontSize) return maxFontSize + 'px';
                return Math.round(d.dy * 0.5) + 'px';
            });

            label.filter(function (d) {
                return d.x < width * 0.3;
            }).attr('x', 5 + sankeyName.nodeWidth()).attr('y', function (d) {
                return d.dy / 2;
            }).attr('text-anchor', 'start');

            label.filter(function (d) {
                return d.x > width * 0.75;
            }).attr('x', -2).attr('y', function (d) {
                return d.dy / 2;
            }).attr('text-anchor', 'end');
        }

        if (stampText != null && stampText.trim().length > 0) {
            var stampTextContainer = svg.append('g');

            var rectWidth = width / 1.5;
            var rectHeight = 80;

            stampTextContainer.append("foreignObject").attr("x", 0).attr("y", 0).attr("width", rectWidth).attr("height", rectHeight).append("xhtml:body").html("<p class='stampText'>" + stampText + "</p>");
        }
    };

    // Initiate rendering for a widget
    var initiateWidgetRendering = function initiateWidgetRendering(configObj) {
        // Get widget specific widgetConfig
        var widgetConfig = sankeyConfigBuilder.configBuilder(cloneDeep(configObj));
        renderWidget(widgetConfig);
    };

    return {
        renderWidget: renderWidget,
        initiateWidgetRendering: initiateWidgetRendering
    };
};

export default sankeyFlow();